'use client';

import Widget from "@/src/components/journal-site/common/widget/widget";
import SearchBar from "@/src/components/main-site/home/search-bar/search-bar";
import {Box} from "@mui/material";
import JournalsSection from "@/src/components/main-site/home/journals-section/journals-section";
import LatestArticleSection from "@/src/components/main-site/home/latest-article-section/latest-article-section";
import LatestPostSection from "@/src/components/main-site/home/latest-post-section/latest-post-section";
import MainJournalSlider from "@/src/components/main-site/home/slider/main-journal-slider/main-journal-slider";
import {stripHTMLTags} from "@/src/utils/strip-html-tags";

export default function MainSiteHome({
                                         mainJournal,
                                         journals,
                                         documents,
                                         posts,
                                         widgets,
                                     }: {
    mainJournal: any;
    journals: any;
    documents: any;
    posts: any;
    widgets: any;
}) {
    return (
        <Box sx={{position: 'relative', paddingY: 1}}>
            <h1 style={{display: 'none'}}>{stripHTMLTags(mainJournal.meta_data?.overview_description)}</h1>
            <SearchBar/>

            {/* Main Journal Slider */}
            <MainJournalSlider journal={mainJournal}/>

            {widgets.find((widget: any) => widget.slug === 'home_widget_3') &&
                <Widget value={widgets.find((widget: any) => widget.slug === 'home_widget_3')}/>}

            {/* Explore Our Journals */}
            <JournalsSection journals={journals}/>
            {/* Latest Articles */}
            <LatestArticleSection articles={documents}/>
            {/* Latest Posts */}
            <LatestPostSection posts={posts}/>

            {widgets.find((widget: any) => widget.slug === 'home_widget_4') &&
                <Widget value={widgets.find((widget: any) => widget.slug === 'home_widget_4')}/>}
            {widgets.find((widget: any) => widget.slug === 'home_widget_5') &&
                <Widget value={widgets.find((widget: any) => widget.slug === 'home_widget_5')}/>}

        </Box>
    )
}
